import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from "../components/Header"
import Footer from "../components/Footer"

import '../styles/index.scss'

import share from "../images/duvel_meta.jpg"
import favicon from '../images/favicon.ico'

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      defaultTitle="Duvel"
      titleTemplate="%s | Duvel"
      meta={[
        { name: 'description', content: '悪魔が誘う、天国の味。' }
      ]}
    >
      <html lang="ja" />
      <meta property="og:description" content="悪魔が誘う、天国の味。" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Duvel" />
      <meta property="og:url" content="http://www.duvel.jp" />
      <meta property="og:title" content="Duvel" />
      <meta property="og:image" content={share} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:description" content="悪魔が誘う、天国の味。" />
      <link rel="shortcut icon" href={favicon} type="image/x-icon" />
    </Helmet>

    <Header />
    
    <main>
      {children()}
    </main>

    <Footer />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js